import { useMemo, useRef, useState } from 'react';

function useSet<T>(value: Array<T> = []) {
  const [values, setValues] = useState(value);
  const set = useRef(new Set<T>());

  const handlers = useMemo(
    () => ({
      add: (value: T) => {
        set.current.add(value);
        setValues(Array.from(set.current));
      },
      remove: (value: T) => {
        set.current.delete(value);

        setValues(Array.from(set.current));
      },
      toggle: (value: T) => {
        if (set.current.has(value)) {
          set.current.delete(value);
        } else {
          set.current.add(value);
        }
        setValues(Array.from(set.current));
      },
      clear: () => {
        set.current.clear();
        setValues(Array.from(set.current));
      },
      set: (newValues: Array<T>) => {
        set.current = new Set(newValues);
        setValues(Array.from(set.current));
      },
    }),
    [],
  );

  return [values, handlers] as const;
}

export default useSet;
